import { useEffect, useState } from "react"
import { MatchMolecule } from "../molecule/matchMolecule"
import { VerticalLayout } from "./layout"
import { InputForm } from "../atoms/input"

export const MatchOptions = ({data,updateContent}) => {
    const [matchObj, setMatchObj] = useState(data?.quiz_answers  ? data.quiz_answers : [{option:"", answer:""},{option:"", answer:""},{option:"", answer:""}])
     const [quizQuestion, setQuizQuestion] = useState(data?.quiz_question || "");
    const changeMatch = (side, index, text) => {
        if (checkValueLength(text)) {
            const copyMatchObj = [...matchObj]
            const copyData = {...data}
            copyMatchObj[index][side] = text
            
            setMatchObj(copyMatchObj)
            copyData["quiz_answer_content"] = copyMatchObj
            copyData["quiz_answers"] = copyMatchObj
            copyData.quiz_question = quizQuestion
            updateContent(copyData)
        }

    }

    
    const checkValueLength = (value) => {
        return (value.length > -1)
    }
    const changeQuestionTitle = (newTitle) => {
        setQuizQuestion(newTitle);
        const copyData = { ...data };
        copyData.quiz_question = newTitle;
        copyData.quiz_answers = matchObj
        copyData.quiz_answer_content = matchObj
        updateContent(copyData);
      };
    
    return (
        <>
        <InputForm title={"Quiz vraag:"} value={quizQuestion} placeholder={"Voeg hier uw vraag in"} typeInput={(newText) => changeQuestionTitle(newText)} />
     
        <VerticalLayout style={{ height : "auto" }}>
            {matchObj.map((match, index) => {
                return (
                   
                    <MatchMolecule
                        leftValueText={(value) => changeMatch('option', index, value)}
                        rightValueText={(value) => changeMatch('answer', index, value)}
                        rang={match.option}
                        number={match.answer}
                    />
                  
                )
            })}


        </VerticalLayout>
        </>
    )
}